import { configureStore } from '@reduxjs/toolkit';
import { gridBlockReducer } from './editorSlice';
import { allVariables } from './allVariableSlice';
import { blockStyleSettings } from './blockStyleSettingsSlice';
import { saveStatus } from './saveStatusSlice';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { allTextDefaultStylesReducer } from './textDefaultStylingSlice';
import { tableRowDefaultStyleReducer } from './tableRowDefaultStyleSlice';
import contextMenu from './contextMenuSlice';
import { documentSettings } from './documentSettingsSlice';

export const rootStore = configureStore({
  reducer: {
    gridBlockReducer,
    allTextDefaultStylesReducer,
    tableRowDefaultStyleReducer,
    allVariables,
    blockStyleSettings,
    saveStatus,
    contextMenu,
    documentSettings,
  },
  devTools: globalThis.env.DEV,
});

export type AppDispatch = typeof rootStore.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export type RootState = ReturnType<typeof rootStore.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
